import { GoogleTranslateInit } from 'volto-google-translate/GoogleTranslateInit';
import { GoogleTranslateWarning } from 'volto-google-translate/GoogleTranslateWarning';
import { googleTranslateReducer } from 'volto-google-translate/reducers';

export default function applyConfig(config) {
  config.settings['volto-google-translate'] = {
    enabled: true,
  };

  config.addonReducers = {
    ...config.addonReducers,
    googleTranslate: googleTranslateReducer,
  };

  config.registerComponent({
    name: 'VoltoGoogleTranslateWarning',
    component: GoogleTranslateWarning,
  });

  config.settings.appExtras = [
    ...config.settings.appExtras,
    {
      match: '',
      component: GoogleTranslateInit,
    },
  ];

  return config;
}
